import { t } from 'i18next'

import { OperationConfirmationState } from '../../../../common/validations'

export const resolveOperationConfirmationHeadingText = (
  state: OperationConfirmationState
) => {
  switch (state) {
    case OperationConfirmationState.CONFIRMED:
      return t('common:thankYou')
    default:
      return ''
  }
}
